import { Button, Dialog, Stack, Typography, useTheme } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import { useTranslation } from 'react-i18next'
import ImageContainer from 'components/atoms/container/ImageContainer'
import {
  OfficeFileIcon,
  ConversationChatIcon,
  SuccessPeakIcon
} from 'components/atoms/Icons'
import { trackEvent } from 'services/amplitudeTracking'
import SharePublicRolePlayButton, {
  rolePlayLink
} from 'components/molecules/rolePlay/SharePublicRolePlayButton'
import { useSearchParams } from 'react-router-dom'
import { useState } from 'react'

const headerImg = require('assets/images/publicRoleplayHead.gif')

const PublicRolePlayHeader = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const [searchParams] = useSearchParams()
  const [openCopyLink, setOpenCopyLink] = useState(
    searchParams.get('copyLink') === 'true'
  )

  const SecondaryBox = ({ icon, index, text }) => (
    <BoxWithBackground
      backgroundColor={theme.palette.background.yellow}
      borderRadius={5}
      sx={{ maxWidth: 388, padding: 10 }}>
      <RowStack spacing={8} alignItems={'flex-start'}>
        {icon}

        <RowStack spacing={5} alignItems={'flex-start'}>
          <Typography variant='deskBody1' sx={{ fontWeight: 600 }}>
            {`${index}.`}
          </Typography>
          <Typography variant='deskBody1' sx={{ fontWeight: 600 }}>
            {text}
          </Typography>
        </RowStack>
      </RowStack>
    </BoxWithBackground>
  )

  return (
    <>
      <BoxWithBackground
        sx={{
          borderRadius: 0,
          backgroundColor: colors.MutedTeal50
        }}
        style={{ paddingBottom: 120 }}>
        <Stack
          sx={[
            theme.publicRolePlay.head.bannerStack,
            theme.publicRolePlay.container
          ]}>
          <Stack sx={theme.publicRolePlay.head.typoStack}>
            <Stack spacing={4}>
              <Stack>
                <Typography variant='h4' color={theme.palette.primary.main}>
                  {t('publicRolePlay.airePractice')}
                </Typography>
                <Typography sx={theme.publicRolePlay.head.h1}>
                  {t('publicRolePlay.rolePlayPoweredAI')}
                </Typography>
              </Stack>

              <Typography variant='deskBody1'>
                {t('publicRolePlay.welcomeToAire')}
              </Typography>
            </Stack>

            <Stack
              sx={[
                theme.publicRolePlay.stack,
                theme.publicRolePlay.head.bannerBtns
              ]}>
              <Button
                variant='contained'
                onClick={() => {
                  window.scrollTo({
                    top:
                      document.getElementById('rolePlayHeading')?.offsetTop -
                      200,
                    behavior: 'smooth'
                  })
                  trackEvent('Begin Practice', { location: 'landing' })
                }}>
                {t('publicRolePlay.beginPracticingNow')}
              </Button>

              <SharePublicRolePlayButton
                label={t('publicRolePlay.shareAirePractice')}
                trackLocation='landing'
              />
            </Stack>
          </Stack>

          <ImageContainer
            sx={theme.publicRolePlay.head.image}
            src={headerImg}
            alt='header image'
          />
        </Stack>
      </BoxWithBackground>

      <InCardStack sx={theme.publicRolePlay.head.expectContainer}>
        <Typography variant='h1'>{t('publicRolePlay.whatToExpect')}</Typography>

        <Stack sx={[theme.publicRolePlay.stack, { gap: 7 }]}>
          <SecondaryBox
            icon={<OfficeFileIcon />}
            index={1}
            text={t('publicRolePlay.reviewTheObjective')}
          />

          <SecondaryBox
            icon={<ConversationChatIcon />}
            index={2}
            text={t('publicRolePlay.selectYourChallenge')}
          />

          <SecondaryBox
            icon={<SuccessPeakIcon />}
            index={3}
            text={t('publicRolePlay.completeThePractice')}
          />
        </Stack>
      </InCardStack>
      {/* Success Dialog */}
      <Dialog open={openCopyLink} sx={theme.publicRolePlay.result.thanksDialog} maxWidth='sm'>
        <InCardStack spacing={16}>
          <InCardStack spacing={8} textAlign={'center'}>
            <Typography sx={theme.publicRolePlay.result.heading}>
              {t('publicRolePlay.shareAIRE')}
            </Typography>
            <Typography variant='h4' fontWeight={400}>
              {t('publicRolePlay.shareDirectly')}
            </Typography>
            <Typography variant='h4' fontWeight={400}>
              {rolePlayLink}
            </Typography>
          </InCardStack>
          <SharePublicRolePlayButton
            variant='contained'
            label={t('fullReport.copyLink')}
            handleClickCallback={() => setOpenCopyLink(false)}
            trackLocation='email'
          />
        </InCardStack>
      </Dialog>
    </>
  )
}

export default PublicRolePlayHeader
